<template>
    <div  class="lras__header mt-3 mb-5 d-flex justify-content-between flex-wrap align-items-baseline">
            <div class="lras__tabs">
                <router-link class="tab-link" to="/imar">ИМАР</router-link>
                <router-link class="tab-link" to="/ippsu">ИППСУ</router-link>
            </div>
            <div class="lras__header-block d-flex align-items-sm-baseline mt-3 flex-sm-row">
                <custom-check-box  class="p-0 m-0" @change="changeWork($event)" v-model="isWork">Ищу работу</custom-check-box>
                <button class="questions-link m-0 mx-sm-4 d-flex justify-content-between align-items-center" v-if="pollUid" @click="loadResultFile">
                    <i class="fas fa-file"></i>
                    Анкета
                </button>
            </div>
        </div>
</template>

<script>
import CustomCheckBox from "@/common/ui/CustomCheckBox";
import Constants from '@/common/constants'
import API from '@/modules/poll/api/poll'
import APIVacancy from '@/modules/vacancy/api/vacancy'

export default {
    name: "HeaderSubComponent",
    components: {CustomCheckBox},
    created() {
        //загружаем данные ищет ли работу
        APIVacancy.getIsSearch().then(response => {
            this.isWork = response.data.success;
        });

        //загружаем данные по анкете
        API.getResultForUser().then(response => {
            this.pollUid = response.data.success ? response.data.message : null;
        });
    },

  data() {
        return {
            isWork: false,
            pollUid: null,
        }
    },
  mounted() {

  },
  methods: {

        changeWork(e) {
            console.log(e);
            if(this.isWork) {
                var alertOptions = {
                    title: 'Подтверждение',
                    text: 'Вы действительно хотите получить содействие в поиске работы?',
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Нет',
                    showCancelButton: true,
                    icon: 'warning',
                };
                Constants.alert.fire(alertOptions).then((res) => {
                    this.isWork = res.isConfirmed;
                    if(res.isConfirmed)
                        this.$router.push({path: '/search-job'});


                });
            } else {
                //на всякий случай отправляем запрос, что нужно приостановить
                APIVacancy.stopSearch();
            }
            
        },
        loadResultFile() {
            API.exportFile(this.pollUid)
        }
    }
}
</script>
<style scoped lang="scss">
@import '/src/assets/theme/default/colors.scss';
.questions-link {
    padding: 12px 20px;
    font-weight: 600;
    background: #FFFFFF;
    min-width: 120px;
    box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    border: none;
    text-decoration: none;
    color: $blue-light;
}
.fas, .fa-file{
    font-size: 18px;
    color: $blue-light;
}
@media (max-width: 767px){
    .lras__header-block{
        width: 100%;
        gap: 8px;
        justify-content: space-between;
        align-items: center;
    }
}
</style>